import { SelfBillingPaymentStatus } from '../../constants/entity/selfBillingPaymentStatus';
import { apiService } from '../apiService';
import { EntityPaymentMethodDetails } from '../../interfaces/entityPaymentMethodDetails';

type SelfBillingPaymentStatusResponse = {
  entityId: number;
  selfBillingEntityPaymentStatus: SelfBillingPaymentStatus;
};

type EntityExpirationCardDateResponse = {
  date: string; //11.01.2026
};

export const entityPaymentService = {
  async payManually(entityId: number) {
    const params = { entityID: entityId };

    const resp = await apiService.post('api/super/subscription/pay-manually', null, {
      params,
    });

    return resp.data;
  },

  async getEntityExpirationCardDate() {
    const resp = await apiService.get<EntityExpirationCardDateResponse>(
      'api/admin/entity-expire-card',
    );

    return resp.data;
  },

  async getSelfBillingPaymentStatus(entityId: number) {
    const resp = await apiService.get<SelfBillingPaymentStatusResponse>(
      `/api/entity/${entityId}/payment/self-billing/status`,
    );

    return resp.data;
  },

  async getEntityPaymentMethodDetails(
    entityId: number,
    config: { ignoreErrorCodes?: number[] } = {},
  ) {
    const resp = await apiService.get<EntityPaymentMethodDetails>(
      `/api/admin/entity/${entityId}/payment/details`,
      config,
    );

    return resp.data;
  },
};
